import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { Box, DashboardModule, Link } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import { generateUrls } from '@hooks/useProviderPriceList'
import useProviderPriceLists from '@hooks/useProviderPriceLists'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import ProviderPriceListItem from './ProviderPriceListItem'

const buildPageFilterFields = () => {
  const style = { marginBottom: 16 }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title or ID',
    },
  ]
}

const ProviderPriceLists = (props: {serviceProductId: number}) => {
  const { serviceProductId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const options = {
    filters: { ...pageFilters, service_product_id: serviceProductId },
    performHttpRequests: !!serviceProductId,
    requestOptions: {
      include_provider_assigned_service_product_ids: true,
      include_provider_price_list_provider: true,
    },
  }
  const providerPricesListsPayload = useProviderPriceLists(options)

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredProviderPriceLists,
    filteredProviderPriceListsCount,
    hasFilteredProviderPriceLists,
    loading,
  } = providerPricesListsPayload

  const { providerPriceListsIndexUrl } = generateUrls()

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-price-lists' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Price Lists"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      <Box flexDirection="column">
        {!loading && !hasFilteredProviderPriceLists && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Price Lists present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              You can create a price list
              <Link href={`${providerPriceListsIndexUrl}?redirect=${generateRedirectUrl()}`}> here</Link>.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredProviderPriceLists && (
          // @ts-expect-error TS2322
          <DashboardModule.ScrollableSection flexDirection="column">
            {filteredProviderPriceLists.map(providerPriceListItem => (
              <ProviderPriceListItem
                key={providerPriceListItem.id}
                providerPriceListItem={providerPriceListItem}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredProviderPriceListsCount}
          loading={loading}
        />
      </Box>
    </DashboardModule>
  )
}
export default ProviderPriceLists
